module.exports = __webpack_public_path__ + "img/coating-scratch.dfdefa38.svg";